// extracted by mini-css-extract-plugin
export default {"container":"style_container__Tbs35","heading":"style_heading__qdOSx","strong":"style_strong__fVZxz","text":"style_text__JrJHM"};